{
  "attachAria": "Datei anhängen",
  "emptyHint": "Beschreibe dein Anliegen — der Support antwortet dir hier",
  "emptyTitle": "Noch keine Nachrichten",
  "fileOpenAria": "Anhang öffnen",
  "logAria": "Unterhaltung zur Anfrage",
  "newMessages": "Neue Nachrichten",
  "placeholder": "Nachricht schreiben…",
  "placeholderDisabled": "Nachrichten sind vorübergehend nicht verfügbar",
  "previewAria": "Anhang ansehen",
  "previewCloseAria": "Vorschau schließen",
  "removeAttachmentAria": "Datei entfernen",
  "retry": "Erneut versuchen",
  "screenshotAria": "Screenshot aufnehmen",
  "seen": "Gelesen",
  "sendAria": "Nachricht senden",
  "sendFailed": "Nachricht konnte nicht gesendet werden",
  "sending": "Wird gesendet…",
  "student": "Schüler",
  "supportName": "Skyeng-Support",
  "today": "Heute",
  "yesterday": "Gestern",
  "you": "Du"
}
